import {
  AdminToolsIcon,
  ArchiveIcon,
  GroupAddIcon,
  MoreVerticalOutlineIcon,
  OpenInNew1OutlineIcon,
  TagsIcon,
} from '@carboncopyco/icons';
import {
  Button,
  Dropdown,
  DropdownItem,
  TooltipBubble,
} from '@carboncopyco/ui';

export interface WorkspaceDropdownProps {
  isMenuOpen: boolean;
  setIsMenuOpen: () => void;
  setOpenMembersModal: (open: boolean) => void;
  setOpenSettingsModal: (open: boolean) => void;
  setOpenManageTags: (open: boolean) => void;
  leaveWorkspace: () => void;
  onArchiveWorkspace?: () => void;
  isDefault?: boolean;
}

export const workspaceDropdownTooltipText = {
  members: 'All organization members are part of the default workspace',
  settings: 'Default workspace type and name can’t be edited',
  archive: 'The default workspace can’t be archived',
  leave: 'Leaving the default workspace is not possible',
};

export const WorkspaceDropdown = ({
  isMenuOpen,
  setIsMenuOpen,
  setOpenMembersModal,
  setOpenSettingsModal,
  setOpenManageTags,
  isDefault,
  onArchiveWorkspace,
  leaveWorkspace,
}: WorkspaceDropdownProps) => {
  return (
    <Dropdown
      triggerElement={
        <Button
          aria-label="menu"
          secondary
          link
          icon={<MoreVerticalOutlineIcon />}
        />
      }
      align="start"
      open={isMenuOpen}
      onOpenChange={setIsMenuOpen}
      asChild
    >
      <TooltipBubble
        fixedWidth={false}
        placement="top"
        title={workspaceDropdownTooltipText.members}
        disabled={!isDefault}
      >
        <DropdownItem
          disabled={isDefault}
          iconLeft={<GroupAddIcon size={18} />}
          label="Members"
          onClick={() => setOpenMembersModal(true)}
        />
      </TooltipBubble>
      {setOpenSettingsModal && (
        <DropdownItem
          iconLeft={<AdminToolsIcon size={18} />}
          label="Edit settings"
          onClick={() => setOpenSettingsModal(true)}
        />
      )}
      {setOpenManageTags && (
        <DropdownItem
          iconLeft={<TagsIcon size={18} />}
          label="Manage tags"
          onClick={() => setOpenManageTags(true)}
        />
      )}
      {onArchiveWorkspace && (
        <TooltipBubble
          placement="top"
          title={workspaceDropdownTooltipText.archive}
          disabled={!isDefault}
        >
          <DropdownItem
            iconLeft={<ArchiveIcon size={18} />}
            label="Archive workspace"
            disabled={isDefault}
            onClick={onArchiveWorkspace}
          />
        </TooltipBubble>
      )}
      {leaveWorkspace && (
        <TooltipBubble
          placement="top"
          title={workspaceDropdownTooltipText.leave}
          disabled={!isDefault}
        >
          <DropdownItem
            disabled={isDefault}
            iconLeft={<OpenInNew1OutlineIcon size={18} />}
            label="Leave workspace"
            onClick={leaveWorkspace}
          />
        </TooltipBubble>
      )}
    </Dropdown>
  );
};
